var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuGovernance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.87505,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_1940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5781 32.6953V22.1016H18.4531V32.6953H16.5781ZM24.1406 32.6953V22.1016H26.0156V32.6953H24.1406ZM12.4531 36.4453V34.5703H37.4531V36.4453H12.4531ZM31.4531 32.6953V22.1016H33.3281V32.6953H31.4531ZM12.4531 20.2266V18.5703L24.9531 11.4453L37.4531 18.5703V20.2266H12.4531ZM16.6406 18.3516H33.2656L24.9531 13.6016L16.6406 18.3516Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_1940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7516,
    height: 31.2642,
    fill: "white",
    transform: "translate(9.31641 8.92944)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuGovernance);
export default __webpack_public_path__ + "static/media/icon_menu_governance.cc40eb218f572479f9e5400f5a5c86fc.svg";
export { ForwardRef as ReactComponent };